import { render, staticRenderFns } from "./case-card.vue?vue&type=template&id=514a1757&"
import script from "./case-card.vue?vue&type=script&lang=js&"
export * from "./case-card.vue?vue&type=script&lang=js&"
import style0 from "./case-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports